import React, { Component } from "react";
import Select from "../../common/Select";
import Progress from "../../common/Progress";
import Input from "../../common/Input";
import { api } from "../../common/server";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import AutoSuggestInput from "../../common/AutoSuggestInput";


const mapStateToProps = (state) => ({
  locations: state.locations,
  businessCatergories: state.businessCatergories,
  businesslocationTypes: state.businesslocationTypes,
  rizevo_login_data: state.rizevo_login_data,
  token: state.token,
  postOptions: state.postOptions,
});

export default connect(mapStateToProps)(
  class Onboarding extends Component {
    modal = React.createRef();

    state = {
      active_form: 1,
      cities: [],
      errors: {},
      openHours: {
        Monday: [
          {
            from: "09:00",
            to: "17:00",
          },
        ],
        Tuesday: [
          {
            from: "09:00",
            to: "17:00",
          },
        ],
      },
      locationTypeIsPhysical:
        this.props.businesslocationTypes?.[0]?.name === "Physical Location",
      timeModalIsOpen: false,
    };
    addTime = (ev) => {
      ev.preventDefault();
    };
    close_open = (ev) => {
      this.setState({ timeModalIsOpen: !this.state.timeModalIsOpen });
    };
    next = (ev) => {
      ev.preventDefault();

      const formButton = ev.currentTarget.querySelector("button[type=submit]");
      formButton.classList.add("loading");

      //clear errors
      this.setState({ errors: {} });

      const form = ev.currentTarget;
      const formData = {
        username: form.username.value,
        name: form.name.value,
        email: form?.email?.value ?? "",
        phone_number: form?.phone_number?.value ?? "",
        business_type: form.business_type.value,
        location_type: form.location_type.value,
        address: form.address?.value,
        city: form.city?.value,
        state: form.state?.value,
        country: form.country?.value,
        opening_hours: [],
        referral_source: localStorage.getItem("referral_source"),
        referral_other: localStorage.getItem("referral_other") 

      };
      //rebuild opening hours...
      Object.keys(this.state.openHours).forEach((key) => {
        if (this.state.openHours[key] !== false)
          this.state.openHours[key].forEach((hour) => {
            formData.opening_hours.push({
              week_day: key[0].toLocaleUpperCase() + key.slice(1),
              opening_time: hour.from === "00:00" ? "09:00" : hour.from,
              closing_time: hour.to === "00:00" ? "17:00" : hour.to,
            });
          });
      });


      //create business
      fetch(`${api}/business`, {
        ...this.props.postOptions(),
        body: JSON.stringify(formData),
      })
        .then((res) => {
          formButton.classList.remove("loading");
          return res.json();
        })
        .then((obj) => {
          if (obj.errors)
            obj.errors.map((err) => {
              this.setState({
                errors: { ...this.state.errors, [err.field]: err.message },
              });
            });
          else if (obj.data?.invitation_code) {
            this.setState({
              redirect: `/onboarding/opening_hours`,
            });

            this.props.dispatch({ type: "GET_BUSINESS", data: obj.data });
          }
        });
    };

    handleLocationTypeChange = ({ currentTarget: { value } }) => {
      this.setState({ locationTypeIsPhysical: value === "Physical Location" });
    };

    setCities = (city) => {
      if (this.props.locations)
        this.props.locations.map(({ name, cities }) => {
          if (name.toLowerCase() === city.toLowerCase()) {
            this.setState({ cities });
          }
        });
    };

    openHours = () => {
      return Object.keys(this.state.openHours).map((key) =>
        this.state.openHours[key] !== false ? (
          <div className="input-grid-rapper" onClick={this.close_open}>
            <p className="label">{key}</p>
            {this.state.openHours[key].map((hour) => (
              <div class="input-grid" style={{ pointerEvents: "none" }}>
                <Input type="text" placeholder="00:00" value={hour.from} />
                <span class="seperator">-</span>
                <Input type="text" placeholder="00:00" value={hour.to} />
              </div>
            ))}
          </div>
        ) : (
          ""
        )
      );
    };
    updateHours = (hoursState) => {

      this.setState({
        openHours: { ...this.state.openHours, ...hoursState },
      });
    };

    handleChange = (e) => {
      this.setState({
        [e.target.name]: e.target.value,
      });
    };
    render() {
      return (
        <div className="onboarding-page">
          {this.state.redirect ? <Redirect to={this.state.redirect} /> : ""}

          <Progress total={5} current={2}>
            {/* <h1 className="form-title dsk">Enter your business details</h1> */}
            <div className="form-title dsk">
              Enter your business details
              <p>Provide some quick information about your business.</p>
            </div>
          </Progress>

          <div className="form_step form-page">
            <h1 className="form-title mbl">Enter your business details</h1>
            <div className="form-container">
              <form onSubmit={this.next}>
                <Input
                  label="business/contact name"
                  name="name"
                  placeholder="e.g ABC Salon"
                  type="text"
                  error={this.state.errors.name}
                  required
                />
                <Input
                  label="Username"
                  name="username"
                  placeholder="e.g. abcsalon"
                  type="text"
                  error={this.state.errors.username}
                  required
                />


                <AutoSuggestInput
                  label="Type of Business"
                  name="business_type"
                  value={this.state.business_type}
                  onChange={(e) =>
                    this.setState({ business_type: e.target.value })
                  }
                  placeholder="e.g. Salon, Spa, Consultant."
                  dataList={this.props.businessCatergories}
                  error={this.state.errors.business_type}
                  suggestionsTitle="Suggestions"
                  required
                />

                <Select
                  label="Where do you handle your services?"
                  type="text"
                  name="location_type"
                  placeholder="Select location type"
                  onChange={this.handleLocationTypeChange}
                  error={this.state.errors.location_type}
                  required
                >
                  {this.props.businesslocationTypes?.map((type) => (
                    <option value={type.name}>{type.name}</option>
                  ))}
                </Select>

                {this.state.locationTypeIsPhysical && (
                  <>
                    <Input
                      label="Address"
                      type="text"
                      name="address"
                      placeholder="e.g. 123 Business Street"
                      minLength="3"
                      error={this.state.errors.address}
                      required
                    />
                    <div className="input-grid">
                      <Input
                        label="city/area"
                        type="text"
                        name="city"
                        placeholder="e.g. Lekki"
                        dataList={this.state.cities}
                        required
                      />
                      <Input
                        label="state"
                        type="text"
                        name="state"
                        placeholder="e.g. Lagos"
                        dataList={
                          this.props.locations ? this.props.locations : []
                        }
                        onChangeAction={this.setCities}
                        required
                      />
                    </div>
                  </>
                )}
                <Select
                  label="Country"
                  name="country"
                  placeholder="select country"
                  required
                >
                  <option selected>Nigeria</option>
                </Select>
                <div></div>

                <div>
                  <br></br>

                  <div className="footer flex center space-btw">
                    <button className="default" type="submit">
                      Next
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      );
    }
  }
);
